var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{attrs:{"md":"7"}},[_c('div',{staticClass:"section-title"},[_c('h4',{staticClass:"pl-0 pr-3 pt-3 pb-3"},[_c('span',{staticClass:"pl-0"},[_vm._v("Introduction")])])]),_c('p',{staticClass:"pr-20",staticStyle:{"margin-top":"-30px"}},[_vm._v(" "+_vm._s(this.subtitle)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }